import { type TUsage as TApiUsage } from '@core/api'

import { type TUsage } from '@core/models'

export const convertUsage = (usage: TApiUsage): TUsage => {
    return {
        audioHours: usage.audio_hours,
        projectsCount: usage.projects_count,
        storageUsage: usage.storage_usage,
        transcriptionsThisMonth: usage.transcriptions_this_month,
    }
}
